import { fetchWrapper } from "./api/fetch-wrapper";

import hostname from "./api/config.host";

const apiUrl: string = `${hostname}/aladdin_api/v1`;

export const loginService = {
  signIn,
  refresh,
  logout,
};

async function signIn(body: { email: string; password: string }) {
  return fetchWrapper.post(`${apiUrl}/auth/login/`, body, undefined, true);
}

async function refresh() {
  // Call the refresh endpoint. Server should read the httpOnly refresh cookie
  // and return a new access_token (and possibly refresh cookie again).
  const res = await fetch(`${apiUrl}/auth/refresh/`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
  });

  const text = await res.text().catch(() => "");
  if (!res.ok) {
    const err: any = new Error("Refresh failed");
    err.status = res.status;
    err.text = text;
    return { data: null, status: res.status };
  }

  try {
    return { data: JSON.parse(text), status: res.status };
  } catch (e) {
    return { data: null, status: res.status };
  }
}

async function logout() {
  return fetchWrapper.post(`${apiUrl}/auth/logout/`, {});
}

export async function getUserDetails(oauthTokenHeader: string) {
  return fetchWrapper.get(`${apiUrl}/users/me/`, oauthTokenHeader);
}
